import React, { useState, useEffect } from 'react';
import './LevelAnchors.css';
import { LevelAnchor } from '../LevelAnchor';
import { StringUtilService } from '../../../../../shared/src/services/util/string-util.service';
import { useScrollToElement } from '../../../../../shared/src/hooks/use-scroll-to-element.hook';

export const LevelAnchors = ({
    loyaltyLevels,
}) => {
    const [elementToScroll, setElementToScroll] = useState('');

    useEffect(() => {
        useScrollToElement(elementToScroll);
    }, [elementToScroll]);

    return <div className="loyalty-level-anchors">
        {loyaltyLevels.map(levelData => <LevelAnchor
            key={StringUtilService.stringToKebabCase(levelData.description)}
            levelData={levelData}
            setElementToScroll={setElementToScroll}
        />)}
    </div>;
};
